import { render, staticRenderFns } from "./UsosConsumo.vue?vue&type=template&id=7d535b20&"
import script from "./UsosConsumo.vue?vue&type=script&lang=js&"
export * from "./UsosConsumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports